<template>
  <div class="row space-between week-btns">
    <input type="button" @click="toggle(6)" :style="btnClass(6)" value="S"/>
    <input type="button" @click="toggle(0)" :style="btnClass(0)" value="M"/>
    <input type="button" @click="toggle(1)" :style="btnClass(1)" value="T"/>
    <input type="button" @click="toggle(2)" :style="btnClass(2)" value="W"/>
    <input type="button" @click="toggle(3)" :style="btnClass(3)" value="T" />
    <input type="button" @click="toggle(4)" :style="btnClass(4)" value="F" />
    <input type="button" @click="toggle(5)" :style="btnClass(5)" value="S" />
  </div>
</template>

<script>
export default {
  props: { week: { type: Array, default: () => [] }, color: String, allowEdit: { default: true, type: Boolean }},
  methods: {
    btnClass(weekDay) {
      if (this.week.includes(weekDay)) {
        return {
          color: this.color,
          "border-color": this.color + " !important"
        };
      }
      return {};
    },
    toggle(weekDay) {
      if (!this.allowEdit) {
        return;
      }
      let indexOf = this.week.indexOf(weekDay);
      if (indexOf > -1) {
        this.week.splice(indexOf, 1);
      } else {
        this.week.push(weekDay);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.week-btns {
  > input[type="button"] {
    border: 1px solid #FFFFFF;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    border-radius: 50%;
    padding: .1em .5em;
  }
}

</style>
